module.exports = __webpack_public_path__ + "static/media/36.3691006c.png";